export default class EvaluationPortfolioCtrl {
	constructor ($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, GlobalSrv) {
		// constants
		var evaluationVm = this
		const cacheImage = {}


		evaluationVm.userId = JSON.parse($cookies.get('currentUser')).id
		const ownerPortfolio = {
			userId : evaluationVm.userId
		}

		evaluationVm.users = []
		evaluationVm.evalPortfolio = evalPortfolio
		evaluationVm.getCachedImages = getCachedImages

		activate()

		function activate () {
			getPortfolioForEval()
		}

		function getPortfolioForEval(){
    	PortfolioSrv.getTeacherToEvaluation.get(ownerPortfolio).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        evaluationVm.users = dataReturn.data
	      }
		  }, function (data) {
		      console.log(data)
		    }
	    )
		}

		function getCachedImages(identification) {
			if (cacheImage[identification]) return

			cacheImage[identification] = true

      GlobalSrv.getUserImage.get({identification}).$promise.then(response => {
        // Clona la respuesta para guardarla en caché
        return response.profilePicture
      })

		}


		function evalPortfolio(user){
			$cookies.put('ownerPortfolio', user.userId)
			$state.go('portfolio.evaluationOfPortfolio')
		}
    

	}
}

EvaluationPortfolioCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv','GlobalConfig', '$cookies', '$state', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/evaluationPortfolio/evaluationPortfolioCtrl.js